import React, { useState } from 'react';
import InfoPage, { Section } from '../components/InfoPage';
import { CheckCircle2, Package, Truck, Home, Search } from 'lucide-react';
import { toast } from 'sonner';

const TrackOrder = () => {
  const [orderId, setOrderId] = useState('');
  const [email, setEmail] = useState('');
  const [result, setResult] = useState(null);

  const submit = (e) => {
    e.preventDefault();
    if (!orderId || !email) {
      toast.error('Please enter your order number and email.');
      return;
    }
    // MOCKED tracking response
    const mock = {
      id: orderId.toUpperCase(),
      status: 'In transit',
      eta: 'Wednesday',
      carrier: 'USPS',
      tracking: '9400 1234 5678 9101 1213 14',
      steps: [
        { label: 'Order received', date: 'Mar 4', done: true, icon: CheckCircle2 },
        { label: 'Packed', date: 'Mar 5', done: true, icon: Package },
        { label: 'In transit', date: 'Mar 7', done: true, icon: Truck, active: true },
        { label: 'Out for delivery', date: 'Expected Wed', done: false, icon: Home },
      ],
    };
    setResult(mock);
    toast.success('Order found.');
  };

  return (
    <InfoPage title="Track your order" subtitle="Enter your order number and the email you used at checkout. We'll show you exactly where your bar is.">
      <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-[12px] uppercase tracking-[0.18em] mb-2" style={{ color: '#2D5A3D' }}>
            Order number *
          </label>
          <input
            value={orderId}
            onChange={(e) => setOrderId(e.target.value)}
            placeholder="#YORA-12345"
            className="w-full bg-white border rounded-lg px-4 py-3 text-[14px] focus:outline-none focus:ring-1"
            style={{ borderColor: 'rgba(45,90,61,0.3)', color: '#2C2418' }}
          />
        </div>
        <div>
          <label className="block text-[12px] uppercase tracking-[0.18em] mb-2" style={{ color: '#2D5A3D' }}>
            Email *
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="w-full bg-white border rounded-lg px-4 py-3 text-[14px] focus:outline-none focus:ring-1"
            style={{ borderColor: 'rgba(45,90,61,0.3)', color: '#2C2418' }}
          />
        </div>
        <button
          type="submit"
          className="md:col-span-2 inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-[13px] uppercase tracking-[0.22em] font-semibold btn-hover"
          style={{ backgroundColor: '#2D5A3D', color: '#F5EDDF' }}
        >
          <Search size={16} /> Track order
        </button>
      </form>

      {result && (
        <div className="mt-4 p-6 rounded-2xl" style={{ backgroundColor: '#F5EDE0' }}>
          <div className="flex flex-wrap items-baseline justify-between gap-3 pb-4 border-b" style={{ borderColor: 'rgba(45,90,61,0.15)' }}>
            <div>
              <p className="text-[12px] uppercase tracking-[0.18em] opacity-70" style={{ color: '#2D5A3D' }}>Order</p>
              <p className="text-[18px] font-bold" style={{ color: '#2C2418' }}>{result.id}</p>
            </div>
            <div className="text-right">
              <p className="text-[12px] uppercase tracking-[0.18em] opacity-70" style={{ color: '#2D5A3D' }}>Status</p>
              <p className="text-[16px] font-semibold" style={{ color: '#2D5A3D' }}>{result.status}</p>
              <p className="text-[12px] opacity-70 mt-0.5" style={{ color: '#2C2418' }}>
                Arrives {result.eta} · {result.carrier} · {result.tracking}
              </p>
            </div>
          </div>

          <ol className="mt-6 space-y-5">
            {result.steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <li key={i} className="flex items-start gap-4">
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center shrink-0"
                    style={{
                      backgroundColor: s.done ? '#2D5A3D' : '#FFFFFF',
                      color: s.done ? '#FFFFFF' : '#2D5A3D',
                      border: s.done ? '2px solid #2D5A3D' : '2px solid rgba(45,90,61,0.25)',
                    }}
                  >
                    <Icon size={18} />
                  </div>
                  <div className="flex-1 pt-1">
                    <p className="text-[15px] font-semibold" style={{ color: '#2C2418' }}>
                      {s.label}
                    </p>
                    <p className="text-[12px] opacity-70" style={{ color: '#2C2418' }}>{s.date}</p>
                  </div>
                  {s.active && (
                    <span className="text-[10px] px-2 py-1 rounded-full font-semibold tracking-wide" style={{ backgroundColor: '#2D5A3D', color: '#FFFFFF' }}>
                      NOW
                    </span>
                  )}
                </li>
              );
            })}
          </ol>
        </div>
      )}

      <Section heading="Common questions">
        <p><b>Where do I find my order number?</b> It's in your confirmation email, usually starts with <em>#YORA-</em>.</p>
        <p><b>How long does shipping take?</b> Most orders arrive in 6–9 business days within the US.</p>
        <p><b>Lost or stuck order?</b> Reach our team via the Contact page and we'll sort it out within 24 hours.</p>
      </Section>
    </InfoPage>
  );
};

export default TrackOrder;
